import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemIcon, ListItemText, MenuItem } from '@material-ui/core';
import { VpnKey } from '@material-ui/icons';
import { CentralProviderContext } from '../../../centralProviderContext/CentralProviderContext';
import { centralPublicURL } from '../../../environment.vars';
export function ChangePassword(_a) {
    var closeDropdown = _a.closeDropdown;
    var contextValue = useContext(CentralProviderContext);
    var t = useTranslation().t;
    var centralURL = centralPublicURL;
    if (!contextValue || !contextValue.centralProfile)
        return null;
    var handleClick = function () {
        var element = document.createElement('a');
        var link = "".concat(centralURL, "/change-password/").concat((contextValue.centralProfile).uid, "?language=").concat(contextValue.currentLanguage);
        element.href = link;
        element.target = '_blank';
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
        closeDropdown();
        try {
            element.remove();
        }
        catch (e) {
            element.href = '#';
        }
    };
    return (React.createElement(MenuItem, { onClick: handleClick },
        React.createElement(ListItemIcon, { style: { minWidth: '33px' } },
            React.createElement(VpnKey, { color: "primary" })),
        React.createElement(ListItemText, { primary: t('Change Password') })));
}
//# sourceMappingURL=ChangePassword.js.map